import { render, staticRenderFns } from "./PrescriptionsTable.vue?vue&type=template&id=80d43eae&scoped=true&"
import script from "./PrescriptionsTable.vue?vue&type=script&lang=js&"
export * from "./PrescriptionsTable.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionsTable.vue?vue&type=style&index=0&id=80d43eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d43eae",
  null
  
)

export default component.exports